import type { BeforeRetryHook } from 'ky';
import type { HookGetterArgs } from '../types';

/**
 * Hook that logs retry attempts
 */
export const getLogBeforeRetryHook = ({
  fetchArgs: { url: _url, method, data },
  baseURL,
}: HookGetterArgs): BeforeRetryHook => {
  const logRetryHook: BeforeRetryHook = (_options) => {
    const { retryCount, error } = _options;
    if (process.env.NODE_ENV === 'development') {
      console.debug(`Retrying [${method}] ${baseURL} (attempt ${retryCount.toString()})`, {
        payload: data,
        error,
      });
    }
  };

  return logRetryHook;
};
